<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Usuários'" :showBtn="false" :btnName="''" :btnRoute="''" :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="company">Empresa</label>
                      <input v-model="dataSearch.company" type="text" class="form-control" id="company" name="company">
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="company">Usuário ID</label>
                      <input v-model="dataSearch.userId" type="text" class="form-control" id="userId" name="userId">
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Nome</label>
                      <input v-model="dataSearch.name" type="text" class="form-control" id="name" name="name">
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="email">Email</label>
                      <input v-model="dataSearch.email" type="text" class="form-control" id="email" name="email">
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="cpf">CPF</label>
                      <input v-model="dataSearch.cpf" type="text" class="form-control" id="cpf" name="cpf"
                             maxlength="11">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Banco</label>
                      <input v-model="dataSearch.header" type="text" class="form-control" name="userId"
                             placeholder="UserID" required>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Benefícios</label>
                      <select v-model="dataSearch.type">
                        <option value="0"> Todos</option>
                        <option value="1"> Sem benefícios</option>
                        <option value="2"> Com benefícios sem KYC</option>
                        <option value="3"> KYC em análise</option>
                        <option value="4"> KYC reprovado</option>
                        <option value="5"> KYC aprovado sem cartão</option>
                        <option value="6"> Cartão ativo</option>
                        <option value="7"> Cartão bloqueado</option>
                        <option value="8"> Com beneficios</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <button v-on:click="searchUser()">Pesquisar</button>
                  <button v-on:click="openEmployeeCountReport()" :disabled="loadingEmployeeCountReport"
                          title="Envie um .csv com as colunas: Nome da empresa; Id da empresa">
                    <i class="fa fa-download" aria-hidden="true"></i>
                    {{ loadingEmployeeCountReport ? 'Gerando relatório...' : 'Baixar relatório de usuários por empresa' }}
                  </button>
                  <input ref="employeeCountReportFile" type="file" accept=".csv" style="display: none"
                         v-on:change="generateEmployeeCountReport($event)">
                </div>
              </div>
            </div>

            <full-loading v-if="loading"/>

            <!-- No Result -->
            <div v-if="!loading && (dataUser !== '' && !dataUser.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loading && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loading && dataUser.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box">
                <div class="portlet-title page-count">
                  <div class="caption">
                    <span class="caption-subject font-blue bold uppercase">
                      Quantidade total ({{ dataUser.length }})
                    </span>
                  </div>
                  <div>
                    <span>Página {{currentPage}} / {{totalPages === 0 ? '1' : totalPages}} - Exibindo {{ dataUser.length >= 30 ? '30' : dataUser.length }} de {{dataUserPagination === 0 ? '1' : dataUserPagination}} registros.</span>
                  </div>
                </div>


                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-light table-icon">
                      <thead>
                      <tr>
                        <th> EMPRESA</th>
                        <th> NOME</th>
                        <th> EMAIL</th>
                        <th> FUNÇÃO</th>
                        <th> BENEFÍCIOS</th>
                        <th> ÚLTIMO LOGIN</th>
                        <th> DATA DE CADASTRO</th>
                        <th> AÇÕES</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(a, index) in dataUser" :key="a.id">
                        <td v-tooltip.top-center="a.companyName">{{ a.companyName | limitTo(15) }}</td>
                        <td v-tooltip.top-center="a.name">{{ a.name | limitTo(15) }}</td>
                        <td>{{ a.email }}</td>
                        <td>{{ a.roleStr }}</td>
                        <td>
                          <span v-if="a.type === 0" class="tags-benefits" style="background-color: #98D4FA">
                            {{ a.benefits }}
                          </span>
                          <span v-if="a.type === 1" class="tags-benefits" style="background-color: mediumvioletred">
                            {{ a.benefits }}
                          </span>
                          <span v-if="a.type === 2" class="tags-benefits" style="background-color: blue">
                            {{ a.benefits }}
                          </span>
                          <span v-if="a.type === 3" class="tags-benefits" style="background-color: darkolivegreen">
                            {{ a.benefits }}
                          </span>
                          <span v-if="a.type === 4" class="tags-benefits" style="background-color: red">
                            {{ a.benefits }}
                          </span>
                          <span v-if="a.type === 5" class="tags-benefits" style="background-color: green">
                            {{ a.benefits }}
                          </span>
                          <span v-if="a.type === 6" class="tags-benefits" style="background-color: cyan">
                            {{ a.benefits }}
                          </span>
                          <span v-if="a.type === 7" class="tags-benefits" style="background-color: orange">
                            {{ a.benefits }}
                          </span>
                          <span v-if="a.type === 8" class="tags-benefits" style="background-color: #2D849FFD">
                            {{ a.benefits }}
                          </span>
                        </td>
                        <td>{{ a.lastLogin }}</td>
                        <td>{{ a.createdAt }}</td>
                        <td class="no-wrap">
                          <a v-bind:href="'/usuario/' + a.userId + '/' + dataSearch.header" title="Visualizar"
                             class="btn-to-view">
                            <i class="fa fa-eye" aria-hidden="true"></i> Visualizar
                          </a>
                          <a v-if="a.role === 4" v-on:click="changeUserCompany(a)" title="Alterar usuário de empresa."
                             class="btn-to-edit">
                            <i class="fa fa-pencil" aria-hidden="true"></i> Troca de empresa
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <pagination v-if="!loading && dataUserPagination > 30" :total-items="dataUserPagination" :items-per-page="itemsPerPage" :current-page="currentPage"
                      @update:currentPage="updateValue"/>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../../components/default/topMenu.vue";
import pageHeader from "../../../components/default/pageHeader.vue";
import fullLoading from "../../../components/default/fullLoading.vue";
import swal from 'sweetalert';

import {
  DESACTIVE_ACTIVE,
  CHANGE_USER_FROM_COMPANY,
  COMPANY_EMPLOYEE_COUNT_REPORT,
  USERS
} from "../../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../../msgAlertService";
import Pagination from "../../../components/tools/pagination.vue";

export default {
  name: "all-user",
  components: {
    Pagination,
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 30,
      dataUserPagination: 0,
      loading: false,
      loadingEmployeeCountReport: false,
      failRequest: false,
      dataUser: '',
      dataSearch: {
        header: 'AAAA',
        userId: '',
        name: '',
        email: '',
        company: '',
        cpf: '',
        type: '0',
      }
    }
  },
  methods: {
    updateValue(page) {
      this.searchUser(page)
      this.currentPage = page
    },
    refreshUser() {
      const typeCategory = this.$route.params.type;

      switch (typeCategory) {
        case '4':
          this.dataSearch.userId = this.$route.params.value;
          break;
        case '5':
          this.dataSearch.name = this.$route.params.value;
          break;
        case '6':
          this.dataSearch.cpf = this.$route.params.value;
          break;
        case '7':
          this.dataSearch.email = this.$route.params.value;
          break;
      }
    },
    openEmployeeCountReport() {
      swal({
        title: "Relatório de usuários por empresa",
        text: "Anexe um arquivo .csv em que a primeira coluna é o nome da empresa e a segunda é o Id da empresa.\n\nSerá gerado um .csv com o total de colaboradores e a data do último cadastro de cada empresa.",
        icon: "info",
        buttons: ["Cancelar", "Anexar arquivo"],
      }).then((confirm) => {
        if (confirm)
          this.$refs.employeeCountReportFile.click();
      });
    },
    generateEmployeeCountReport(event) {
      const file = event.target.files[0];
      // limpa o input para permitir enviar o mesmo arquivo novamente
      event.target.value = '';

      if (!file)
        return;

      if (!file.name.toLowerCase().endsWith('.csv')) {
        swal("Aviso", "Selecione um arquivo .csv.", "error");
        return;
      }

      this.loadingEmployeeCountReport = true;

      REQUEST_SERVICE.fileUploadV2(COMPANY_EMPLOYEE_COUNT_REPORT, file, this.dataSearch.header, 'blob').then((response) => {
        const urlResponse = window.URL.createObjectURL(new Blob([response.data], {type: "text/csv"}));
        const a = document.createElement('a');
        a.href = urlResponse;
        a.download = 'relatorio-colaboradores-por-empresa.csv';
        a.click();
        window.URL.revokeObjectURL(urlResponse);

        this.loadingEmployeeCountReport = false;
      }).catch(() => {
        this.loadingEmployeeCountReport = false;
        swal("Aviso", "Não foi possível gerar o relatório. Verifique o arquivo enviado e tente novamente.", "error");
      });
    },
    changeUserCompany(user) {
      swal({
        title: "Aviso",
        text: "Você tem certeza que deseja alterar o usuário de empresa ? \n\n\n Informe o ID da nova empresa, sem o ID não é possível realizar essa operação.",
        icon: "warning",
        buttons: true,
        dangerMode: true,
        content: "input",
      })
        .then((valueInput) => {
          if (valueInput) {
            if (user.userId && user.contentSetting && valueInput) {

              let url = CHANGE_USER_FROM_COMPANY + "?userID=" + user.userId + "&companyId=" + valueInput;
              REQUEST_SERVICE.requestContext('GET', url, user.contentSetting).then((response) => {
                UTIL_SERVICE.console("RESULT CHANGE_USER_FROM_COMPANY:", response.data);

                ALERT_SERVICE.swal("Aviso", response.data, "success");
                this.searchUser();
              }).catch((reason) => {

                ALERT_SERVICE.showMsgError(reason.response.data.erros);
              });
            }
          }
        });
    },
    searchUser(page) {

      this.loading = true;

      let url = USERS + "?t=kkkk";
      if (this.dataSearch.name)
        url += "&name=" + this.dataSearch.name;

      if (this.dataSearch.email)
        url += "&email=" + this.dataSearch.email;

      if (this.dataSearch.company)
        url += "&company=" + this.dataSearch.company;

      if (this.dataSearch.cpf)
        url += "&cpf=" + this.dataSearch.cpf;

      if (this.dataSearch.userId)
        url += "&id=" + this.dataSearch.userId;

      if (this.dataSearch.type)
        url += "&type=" + this.dataSearch.type;

      url += '&r=30'

      if(!page) {
        url += '&p=1'
      } else {
        url += '&p=' + page
      }


      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.requestContext('GET', url, this.dataSearch.header).then((response) => {
        UTIL_SERVICE.console("RESULT SEARCH USER:", response.data);

        this.dataUser = response.data.itens;
        this.dataUserPagination = response.data.totalItens;
        this.loading = false;
        this.failRequest = false;
      }).catch((reason) => {
        this.loading = false;
        this.failRequest = true;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    }
  },
  computed: {
    totalPages() {
      const total = this.dataUserPagination / this.itemsPerPage;
      return total !== Infinity ? Math.ceil(total) : 0;
    }
  },
  beforeMount() {
    this.refreshUser();
  }
}
</script>

<style lang="scss">

.page-count {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tags-benefits {
  display: flex;
  justify-content: center;
  width: 90%;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 4px !important;
  text-align: center;
  color: #FFFFFF !important;
}

// Tooltip
.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/user/allUser/allUser.vue